import _ from 'lodash';
import React from 'react';

import './styles.css';

interface DebouncedInputProps {
  value: string;
  onChange: (enteredInput: string) => any;
  placeholder?: string;
  disabled?: boolean;
}

class DebouncedInput extends React.Component<DebouncedInputProps> {
  state = {
    enteredInput: this.props.value
  };

  debouncedOnChange = _.debounce(
    () => this.props.onChange(this.state.enteredInput),
    300
  );

  onChange = input => {
    this.setState({enteredInput: input.target.value}, this.debouncedOnChange);
  };

  render() {
    const {placeholder, disabled = false} = this.props;
    return (
      <input
        className="DebouncedInput"
        value={this.state.enteredInput}
        onChange={this.onChange}
        placeholder={placeholder}
        type="text"
        disabled={disabled}
      />
    );
  }
}

export default DebouncedInput;
